import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "More"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M176 416q48 0.992 79.488 32.512T288 528q-0.992 48-32.512 79.488T176 640q-48-0.992-79.488-32.512T64 528q0.992-48 32.512-79.488T176 416zM512 416q48 0.992 79.488 32.512T624 528q-0.992 48-32.512 79.488T512 640q-48-0.992-79.488-32.512T400 528q0.992-48 32.512-79.488T512 416z m336 0q48 0.992 79.488 32.512T960 528q-0.992 48-32.512 79.488T848 640q-48-0.992-79.488-32.512T736 528q0.992-48 32.512-79.488T848 416z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var more = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\more.vue"]]);

export { more as default };
